import { SEO } from '../../components';
import {
  Header,
  Footer,
  HeroSection,
  ValuePropsSection,
  FinalCTASection,
  WHY_IDENTIO_ITEMS,
} from '../../components/sections';
import {
  SoftwareDevSolutionsSection,
  SoftwareDevCollaborationSection,
} from '../../components/sections/services';
import { getCanonicalUrl, buildHreflangTags } from '../../lib/siteUrl';

export default function SoftwareDevelopmentPage() {
  return (
    <>
      <SEO
        title="Software Development | Identio"
        description="Level up your business with software development. Quality and industry best practices—from modernizing legacy systems to building new ones with scalability and resilience."
        url={getCanonicalUrl('/services/software-development')}
        alternates={buildHreflangTags('/palvelut/ohjelmistokehitys', '/services/software-development')}
      />
      <Header />
      <main id="main-content" tabIndex={-1}>
        <HeroSection variant="softwareDevelopment" />
        <ValuePropsSection
          title="Quality and industry best practices"
          items={WHY_IDENTIO_ITEMS}
          columns={3}
        />
        <SoftwareDevSolutionsSection />
        <SoftwareDevCollaborationSection />
        <FinalCTASection variant="withForm" showContactSidebar={true} />
      </main>
      <Footer />
    </>
  );
}
